import React from 'react';
import styled from 'styled-components';
import Filters from './filters';
import Sorts from './sorts';

const ActionContainer = styled.div`
  display: flex;

  .sort {
    margin-left: auto;
  }
`;

export default function Actions(props) {
  return (
    <ActionContainer>
      <Filters {...props} />
      <Sorts />
    </ActionContainer>
  );
}
